module.exports = __webpack_public_path__ + "static/fond-logo-de1e6dbaca18485ef436635d4fa26adc.png";